/**
 * © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED
 * Tinder Obsidian v10.18.0
 * Do not edit directly
 * Generated on Fri, 01 Nov 2024 18:19:22 GMT
 */

import { ThemeColor, ThemeGradient } from '../types';
import { alphaColor } from '@tinderapp/ui-utils';

export const COLOR_TRANSPARENT: ThemeColor = '#00000000';
export const COLOR_WHITE: ThemeColor = '#ffffff';
export const COLOR_BLACK: ThemeColor = '#000000';
export const COLOR_GRAY_10: ThemeColor = '#f0f2f4';
export const COLOR_GRAY_15: ThemeColor = '#e9ebee';
export const COLOR_GRAY_20: ThemeColor = '#d4d8de';
export const COLOR_GRAY_30: ThemeColor = '#b9bfc8';
export const COLOR_GRAY_40: ThemeColor = '#939ba7';
export const COLOR_GRAY_50: ThemeColor = '#7c8591';
export const COLOR_GRAY_60: ThemeColor = '#656e7b';
export const COLOR_GRAY_70: ThemeColor = '#505965';
export const COLOR_GRAY_80: ThemeColor = '#3c444f';
export const COLOR_GRAY_90: ThemeColor = '#21262e';
export const COLOR_GRAY_95: ThemeColor = '#111418';
export const COLOR_GRAY_05: ThemeColor = '#f8f8f9';
export const COLOR_GREEN_10: ThemeColor = '#c8ffd1';
export const COLOR_GREEN_15: ThemeColor = '#7cfda3';
export const COLOR_GREEN_20: ThemeColor = '#2df187';
export const COLOR_GREEN_30: ThemeColor = '#21d07c';
export const COLOR_GREEN_40: ThemeColor = '#17af70';
export const COLOR_GREEN_50: ThemeColor = '#129e68';
export const COLOR_GREEN_60: ThemeColor = '#0b7d58';
export const COLOR_GREEN_70: ThemeColor = '#055c45';
export const COLOR_GREEN_80: ThemeColor = '#034b3b';
export const COLOR_GREEN_90: ThemeColor = '#012a23';
export const COLOR_GREEN_95: ThemeColor = '#001916';
export const COLOR_GREEN_05: ThemeColor = '#e3ffe6';
export const COLOR_TEAL_10: ThemeColor = '#b2fff7';
export const COLOR_TEAL_15: ThemeColor = '#74fef2';
export const COLOR_TEAL_20: ThemeColor = '#30f3ef';
export const COLOR_TEAL_30: ThemeColor = '#26d1d2';
export const COLOR_TEAL_40: ThemeColor = '#1dacb0';
export const COLOR_TEAL_50: ThemeColor = '#199a9f';
export const COLOR_TEAL_60: ThemeColor = '#12777e';
export const COLOR_TEAL_70: ThemeColor = '#0c565c';
export const COLOR_TEAL_80: ThemeColor = '#09454c';
export const COLOR_TEAL_90: ThemeColor = '#05262a';
export const COLOR_TEAL_95: ThemeColor = '#031619';
export const COLOR_TEAL_05: ThemeColor = '#d8fff9';
export const COLOR_BLUE_10: ThemeColor = '#e3f4ff';
export const COLOR_BLUE_15: ThemeColor = '#d5eeff';
export const COLOR_BLUE_20: ThemeColor = '#abd9ff';
export const COLOR_BLUE_30: ThemeColor = '#78bdff';
export const COLOR_BLUE_40: ThemeColor = '#47a1ff';
export const COLOR_BLUE_50: ThemeColor = '#1786ff';
export const COLOR_BLUE_60: ThemeColor = '#106bd5';
export const COLOR_BLUE_70: ThemeColor = '#0a53ac';
export const COLOR_BLUE_80: ThemeColor = '#053c82';
export const COLOR_BLUE_90: ThemeColor = '#022658';
export const COLOR_BLUE_95: ThemeColor = '#00132e';
export const COLOR_BLUE_05: ThemeColor = '#eff8ff';
export const COLOR_PURPLE_10: ThemeColor = '#f9e8ff';
export const COLOR_PURPLE_15: ThemeColor = '#f6dcff';
export const COLOR_PURPLE_20: ThemeColor = '#f2d0ff';
export const COLOR_PURPLE_30: ThemeColor = '#dea4ff';
export const COLOR_PURPLE_40: ThemeColor = '#cc7afb';
export const COLOR_PURPLE_50: ThemeColor = '#ba52f5';
export const COLOR_PURPLE_60: ThemeColor = '#a11aeb';
export const COLOR_PURPLE_70: ThemeColor = '#7b05ba';
export const COLOR_PURPLE_80: ThemeColor = '#5d038c';
export const COLOR_PURPLE_90: ThemeColor = '#3f015e';
export const COLOR_PURPLE_95: ThemeColor = '#200030';
export const COLOR_PURPLE_05: ThemeColor = '#fbf2ff';
export const COLOR_FUCHSIA_10: ThemeColor = '#ffe2ff';
export const COLOR_FUCHSIA_15: ThemeColor = '#ffd4ff';
export const COLOR_FUCHSIA_20: ThemeColor = '#ffc5ff';
export const COLOR_FUCHSIA_30: ThemeColor = '#fa93fb';
export const COLOR_FUCHSIA_40: ThemeColor = '#ed4ee7';
export const COLOR_FUCHSIA_50: ThemeColor = '#e010cd';
export const COLOR_FUCHSIA_60: ThemeColor = '#b80ba5';
export const COLOR_FUCHSIA_70: ThemeColor = '#91067e';
export const COLOR_FUCHSIA_80: ThemeColor = '#690359';
export const COLOR_FUCHSIA_90: ThemeColor = '#410136';
export const COLOR_FUCHSIA_95: ThemeColor = '#2d0025';
export const COLOR_FUCHSIA_05: ThemeColor = '#fff1ff';
export const COLOR_RED_10: ThemeColor = '#ffeaea';
export const COLOR_RED_15: ThemeColor = '#ffdfdf';
export const COLOR_RED_20: ThemeColor = '#ffd4d3';
export const COLOR_RED_30: ThemeColor = '#ffaaa7';
export const COLOR_RED_40: ThemeColor = '#fa6f68';
export const COLOR_RED_50: ThemeColor = '#f13b2d';
export const COLOR_RED_60: ThemeColor = '#c62c1e';
export const COLOR_RED_70: ThemeColor = '#9b1f11';
export const COLOR_RED_80: ThemeColor = '#701408';
export const COLOR_RED_90: ThemeColor = '#450b03';
export const COLOR_RED_95: ThemeColor = '#2f0701';
export const COLOR_RED_05: ThemeColor = '#fff5f4';
export const COLOR_YELLOW_ORANGE_10: ThemeColor = '#fff8a1';
export const COLOR_YELLOW_ORANGE_15: ThemeColor = '#ffdd6b';
export const COLOR_YELLOW_ORANGE_20: ThemeColor = '#fecd51';
export const COLOR_YELLOW_ORANGE_30: ThemeColor = '#f8a81f';
export const COLOR_YELLOW_ORANGE_40: ThemeColor = '#f59307';
export const COLOR_YELLOW_ORANGE_50: ThemeColor = '#cd7105';
export const COLOR_YELLOW_ORANGE_60: ThemeColor = '#a55303';
export const COLOR_YELLOW_ORANGE_70: ThemeColor = '#7d3902';
export const COLOR_YELLOW_ORANGE_80: ThemeColor = '#692d01';
export const COLOR_YELLOW_ORANGE_90: ThemeColor = '#411900';
export const COLOR_YELLOW_ORANGE_95: ThemeColor = '#2d1000';
export const COLOR_YELLOW_ORANGE_05: ThemeColor = '#fffbc8';
export const COLOR_GOLD_10: ThemeColor = '#fff2bf';
export const COLOR_GOLD_15: ThemeColor = '#ffe8a5';
export const COLOR_GOLD_20: ThemeColor = '#f7d472';
export const COLOR_GOLD_30: ThemeColor = '#e6af16';
export const COLOR_GOLD_40: ThemeColor = '#c1920f';
export const COLOR_GOLD_50: ThemeColor = '#ae830c';
export const COLOR_GOLD_60: ThemeColor = '#896707';
export const COLOR_GOLD_70: ThemeColor = '#644a03';
export const COLOR_GOLD_80: ThemeColor = '#513c02';
export const COLOR_GOLD_90: ThemeColor = '#2c2000';
export const COLOR_GOLD_95: ThemeColor = '#191300';
export const COLOR_GOLD_05: ThemeColor = '#fff8db';
export const COLOR_BRAND_PRIMARY: ThemeColor = '#ff4458';
export const COLOR_BRAND_PRIMARY_A11Y: ThemeColor = '#d4004f';
export const COLOR_BRAND_GRADIENT_START: ThemeColor = '#fd267a';
export const COLOR_BRAND_GRADIENT_END: ThemeColor = '#ff6036';
export const COLOR_THIRD_PARTY_SPOTIFY_PRIMARY: ThemeColor = '#1ed760';
export const COLOR_THIRD_PARTY_SPOTIFY_PRIMARY_INVERSE: ThemeColor = '#191414';
export const COLOR_THIRD_PARTY_NOONLIGHT_PRIMARY: ThemeColor = '#166efb';
export const COLOR_THIRD_PARTY_NOONLIGHT_SECONDARY: ThemeColor = '#81b1fa';
export const COLOR_THIRD_PARTY_FACEBOOK_PRIMARY: ThemeColor = '#1877f2';
export const COLOR_THIRD_PARTY_LINE_PRIMARY: ThemeColor = '#06c755';
export const COLOR_THIRD_PARTY_LINE_A11Y: ThemeColor = '#01ac47';
export const COLOR_VAULT_INDIGO_20: ThemeColor = '#dfd9ff';
export const COLOR_VAULT_INDIGO_95: ThemeColor = '#110c2b';
export const COLOR_VAULT_PRIMARY: ThemeColor = '#5f44ea';
export const COLOR_VAULT_PRIMARY_LIGHT: ThemeColor = '#7d65fc';
export const COLOR_MATCH_EXPIRATION_PRIMARY: ThemeColor = '#c6003c';
export const COLOR_MATCH_EXPIRATION_SECONDARY: ThemeColor = '#d30ab7';
export const COLOR_MATCH_EXPIRATION_PRIMARY_ON_DARK: ThemeColor = '#fe004d';
export const COLOR_SPARKS_GRAY_BLUE_15: ThemeColor = '#eff2fb';
export const COLOR_SPARKS_GRAY_BLUE_30: ThemeColor = '#d5ddf4';
export const COLOR_SPARKS_GRAY_BLUE_80: ThemeColor = '#383838';
export const COLOR_SPARKS_GRAY_BLUE_90: ThemeColor = '#232835';
export const COLOR_SPARKS_YELLOW_20: ThemeColor = '#f1f505';
export const COLOR_SPARKS_YELLOW_30: ThemeColor = '#fef300';
export const COLOR_SPARKS_ORANGE_50: ThemeColor = '#eb7100';
export const COLOR_SPARKS_RED_60: ThemeColor = '#e80037';
export const COLOR_SPARKS_TEAL_20: ThemeColor = '#00f5ff';
export const COLOR_SPARKS_BLUE_50: ThemeColor = '#0a98ff';
export const COLOR_SPARKS_BLUE_70: ThemeColor = '#0057ff';
export const COLOR_SPARKS_GREEN_20: ThemeColor = '#b8ff5f';
export const COLOR_SPARKS_GREEN_30: ThemeColor = '#72e15d';
export const COLOR_SPARKS_GREEN_40: ThemeColor = '#03aa65';
export const COLOR_SPARKS_PURPLE_60: ThemeColor = '#9c27ff';
export const COLOR_SPARKS_PINK_45: ThemeColor = '#ff1bf8';
export const COLOR_OPACITY_BLACK_10: ThemeColor = alphaColor(COLOR_BLACK, 0.098);
export const COLOR_OPACITY_BLACK_15: ThemeColor = alphaColor(COLOR_BLACK, 0.149);
export const COLOR_OPACITY_BLACK_20: ThemeColor = alphaColor(COLOR_BLACK, 0.2);
export const COLOR_OPACITY_BLACK_30: ThemeColor = alphaColor(COLOR_BLACK, 0.302);
export const COLOR_OPACITY_BLACK_40: ThemeColor = alphaColor(COLOR_BLACK, 0.4);
export const COLOR_OPACITY_BLACK_50: ThemeColor = alphaColor(COLOR_BLACK, 0.502);
export const COLOR_OPACITY_BLACK_60: ThemeColor = alphaColor(COLOR_BLACK, 0.6);
export const COLOR_OPACITY_BLACK_70: ThemeColor = alphaColor(COLOR_BLACK, 0.702);
export const COLOR_OPACITY_BLACK_80: ThemeColor = alphaColor(COLOR_BLACK, 0.8);
export const COLOR_OPACITY_BLACK_90: ThemeColor = alphaColor(COLOR_BLACK, 0.902);
export const COLOR_OPACITY_BLACK_95: ThemeColor = alphaColor(COLOR_BLACK, 0.949);
export const COLOR_OPACITY_BLACK_05: ThemeColor = alphaColor(COLOR_BLACK, 0.051);
export const COLOR_OPACITY_WHITE_10: ThemeColor = alphaColor(COLOR_WHITE, 0.098);
export const COLOR_OPACITY_WHITE_15: ThemeColor = alphaColor(COLOR_WHITE, 0.149);
export const COLOR_OPACITY_WHITE_20: ThemeColor = alphaColor(COLOR_WHITE, 0.2);
export const COLOR_OPACITY_WHITE_30: ThemeColor = alphaColor(COLOR_WHITE, 0.302);
export const COLOR_OPACITY_WHITE_40: ThemeColor = alphaColor(COLOR_WHITE, 0.4);
export const COLOR_OPACITY_WHITE_50: ThemeColor = alphaColor(COLOR_WHITE, 0.502);
export const COLOR_OPACITY_WHITE_60: ThemeColor = alphaColor(COLOR_WHITE, 0.6);
export const COLOR_OPACITY_WHITE_70: ThemeColor = alphaColor(COLOR_WHITE, 0.702);
export const COLOR_OPACITY_WHITE_80: ThemeColor = alphaColor(COLOR_WHITE, 0.8);
export const COLOR_OPACITY_WHITE_90: ThemeColor = alphaColor(COLOR_WHITE, 0.902);
export const COLOR_OPACITY_WHITE_95: ThemeColor = alphaColor(COLOR_WHITE, 0.949);
export const COLOR_OPACITY_WHITE_05: ThemeColor = alphaColor(COLOR_WHITE, 0.051);
export const GRADIENT_BRAND_GRADIENT: ThemeGradient = {
  angle: 45,
  colors: [COLOR_BRAND_GRADIENT_START, COLOR_BRAND_GRADIENT_END],
  positions: [0, 1],
};
export const GRADIENT_BRAND_SUBTLE: ThemeGradient = {
  angle: 0,
  colors: [COLOR_WHITE, COLOR_RED_20],
  positions: [0, 1],
};
export const GRADIENT_BRAND_SUBTLE_ON_DARK: ThemeGradient = {
  angle: 0,
  colors: [COLOR_GRAY_95, COLOR_RED_95],
  positions: [0, 1],
};
export const GRADIENT_GAMEPAD_REWIND: ThemeGradient = {
  angle: 45,
  colors: [COLOR_YELLOW_ORANGE_30, COLOR_YELLOW_ORANGE_15],
  positions: [0, 1],
};
export const GRADIENT_GAMEPAD_REWIND_ON_DARK: ThemeGradient = {
  angle: 45,
  colors: [COLOR_YELLOW_ORANGE_40, COLOR_YELLOW_ORANGE_15],
  positions: [0, 1],
};
export const GRADIENT_GAMEPAD_NOPE_ON_DARK: ThemeGradient = {
  angle: 45,
  colors: [COLOR_RED_50, COLOR_FUCHSIA_50],
  positions: [0, 1],
};
export const GRADIENT_GAMEPAD_SUPER_LIKE: ThemeGradient = {
  angle: 45,
  colors: [COLOR_BLUE_40, COLOR_TEAL_20],
  positions: [0, 1],
};
export const GRADIENT_GAMEPAD_SUPER_LIKE_ON_DARK: ThemeGradient = {
  angle: 45,
  colors: [COLOR_BLUE_50, COLOR_TEAL_15],
  positions: [0, 1],
};
export const GRADIENT_GAMEPAD_SUPER_LIKE_ON_LIGHT: ThemeGradient = {
  angle: 45,
  colors: [COLOR_BLUE_50, COLOR_TEAL_50],
  positions: [0, 1],
};
export const GRADIENT_GAMEPAD_SUPER_LIKE_SUBTLE: ThemeGradient = {
  angle: 0,
  colors: [COLOR_WHITE, COLOR_BLUE_15],
  positions: [0, 1],
};
export const GRADIENT_GAMEPAD_SUPER_LIKE_SUBTLE_ON_DARK: ThemeGradient = {
  angle: 0,
  colors: [COLOR_GRAY_95, COLOR_BLUE_90],
  positions: [0, 1],
};
export const GRADIENT_GAMEPAD_LIKE: ThemeGradient = {
  angle: 45,
  colors: [COLOR_GREEN_30, COLOR_TEAL_20],
  positions: [0, 1],
};
export const GRADIENT_GAMEPAD_LIKE_ON_DARK: ThemeGradient = {
  angle: 45,
  colors: [COLOR_GREEN_20, COLOR_TEAL_15],
  positions: [0, 1],
};
export const GRADIENT_GAMEPAD_LIKE_ON_LIGHT: ThemeGradient = {
  angle: 45,
  colors: [COLOR_GREEN_50, COLOR_TEAL_50],
  positions: [0, 1],
};
export const GRADIENT_GAMEPAD_LIKE_SUBTLE: ThemeGradient = {
  angle: 0,
  colors: [COLOR_WHITE, COLOR_GREEN_10],
  positions: [0, 1],
};
export const GRADIENT_GAMEPAD_LIKE_SUBTLE_ON_DARK: ThemeGradient = {
  angle: 0,
  colors: [COLOR_GRAY_95, COLOR_GREEN_90],
  positions: [0, 1],
};
export const GRADIENT_GAMEPAD_BOOST: ThemeGradient = {
  angle: 45,
  colors: [COLOR_PURPLE_60, COLOR_PURPLE_40],
  positions: [0, 1],
};
export const GRADIENT_GAMEPAD_BOOST_ON_DARK: ThemeGradient = {
  angle: 45,
  colors: [COLOR_PURPLE_60, COLOR_FUCHSIA_50],
  positions: [0, 1],
};
export const GRADIENT_GAMEPAD_BOOST_SUBTLE: ThemeGradient = {
  angle: 0,
  colors: [COLOR_WHITE, COLOR_PURPLE_15],
  positions: [0, 1],
};
export const GRADIENT_GAMEPAD_BOOST_SUBTLE_ON_DARK: ThemeGradient = {
  angle: 0,
  colors: [COLOR_GRAY_95, COLOR_PURPLE_90],
  positions: [0, 1],
};
export const GRADIENT_GAMEPAD_SUPER_BOOST: ThemeGradient = {
  angle: 45,
  colors: [COLOR_PURPLE_50, COLOR_FUCHSIA_30],
  positions: [0, 1],
};
export const GRADIENT_GAMEPAD_SUPER_BOOST_ON_DARK: ThemeGradient = {
  angle: 45,
  colors: [COLOR_PURPLE_50, COLOR_FUCHSIA_30],
  positions: [0, 1],
};
export const GRADIENT_GAMEPAD_SUPER_BOOST_SUBTLE: ThemeGradient = {
  angle: 0,
  colors: [COLOR_WHITE, COLOR_FUCHSIA_15],
  positions: [0, 1],
};
export const GRADIENT_GAMEPAD_SUPER_BOOST_SUBTLE_ON_DARK: ThemeGradient = {
  angle: 0,
  colors: [COLOR_GRAY_95, COLOR_FUCHSIA_90],
  positions: [0, 1],
};
export const GRADIENT_GAMEPAD_SPARKS_REWIND: ThemeGradient = {
  angle: 315,
  colors: [COLOR_YELLOW_ORANGE_30, COLOR_SPARKS_YELLOW_30],
  positions: [0, 1],
};
export const GRADIENT_GAMEPAD_SPARKS_NOPE: ThemeGradient = {
  angle: 315,
  colors: [COLOR_RED_50, COLOR_SPARKS_PINK_45],
  positions: [0, 1],
};
export const GRADIENT_GAMEPAD_SPARKS_SUPER_LIKE: ThemeGradient = {
  angle: 315,
  colors: [COLOR_SPARKS_BLUE_70, COLOR_SPARKS_TEAL_20],
  positions: [0, 1],
};
export const GRADIENT_GAMEPAD_SPARKS_LIKE: ThemeGradient = {
  angle: 315,
  colors: [COLOR_SPARKS_GREEN_40, COLOR_SPARKS_YELLOW_20],
  positions: [0, 1],
};
export const GRADIENT_GAMEPAD_SPARKS_BOOST: ThemeGradient = {
  angle: 315,
  colors: [COLOR_PURPLE_50, COLOR_FUCHSIA_40],
  positions: [0, 1],
};
export const GRADIENT_EXPLORE_ATTRIBUTION_GRADIENT: ThemeGradient = {
  angle: 90,
  colors: [COLOR_BRAND_PRIMARY_A11Y, COLOR_FUCHSIA_70],
  positions: [0, 1],
};
export const GRADIENT_FESTIVAL_MODE_GRADIENT: ThemeGradient = {
  angle: 90,
  colors: [COLOR_BLUE_80, COLOR_PURPLE_60],
  positions: [0, 1],
};
export const GRADIENT_SPOTIFY_MUSIC_MODE_GRADIENT: ThemeGradient = {
  angle: 90,
  colors: [COLOR_GREEN_90, COLOR_GREEN_70],
  positions: [0, 1],
};
export const GRADIENT_HOT_TAKES_GRADIENT: ThemeGradient = {
  angle: 90,
  colors: [COLOR_PURPLE_80, COLOR_FUCHSIA_60],
  positions: [0, 1],
};
export const GRADIENT_PASSIONS_GRADIENT: ThemeGradient = {
  angle: 90,
  colors: [COLOR_BRAND_GRADIENT_END, COLOR_FUCHSIA_50],
  positions: [0, 1],
};
export const GRADIENT_VIBES_GRADIENT: ThemeGradient = {
  angle: 45,
  colors: [COLOR_YELLOW_ORANGE_30, COLOR_FUCHSIA_50, COLOR_TEAL_20],
  positions: [0, 0.5, 1],
};
export const GRADIENT_REVENUE_GOLD: ThemeGradient = {
  angle: 45,
  colors: [COLOR_GOLD_30, COLOR_GOLD_20],
  positions: [0, 1],
};
export const GRADIENT_REVENUE_GOLD_SHINE: ThemeGradient = {
  angle: 45,
  colors: [COLOR_GOLD_30, COLOR_GOLD_20, COLOR_GOLD_30],
  positions: [0, 0.5, 1],
};
export const GRADIENT_REVENUE_GOLD_SHINE_ANIMATION: ThemeGradient = {
  angle: 45,
  colors: [
    COLOR_GOLD_20,
    COLOR_GOLD_20,
    COLOR_GOLD_30,
    COLOR_GOLD_20,
    COLOR_GOLD_15,
    COLOR_GOLD_20,
    COLOR_GOLD_30,
    COLOR_GOLD_20,
    COLOR_GOLD_20,
  ],
  positions: [0, 0.125, 0.25, 0.375, 0.5, 0.625, 0.75, 0.875, 1],
};
export const GRADIENT_REVENUE_GOLD_ON_DARK: ThemeGradient = {
  angle: 45,
  colors: [COLOR_GOLD_30, COLOR_GOLD_15],
  positions: [0, 1],
};
export const GRADIENT_REVENUE_GOLD_SHINE_ON_DARK: ThemeGradient = {
  angle: 45,
  colors: [COLOR_GOLD_30, COLOR_GOLD_20, COLOR_GOLD_30],
  positions: [0, 0.5, 1],
};
export const GRADIENT_REVENUE_GOLD_SHINE_ANIMATION_ON_DARK: ThemeGradient = {
  angle: 45,
  colors: [
    COLOR_GOLD_20,
    COLOR_GOLD_20,
    COLOR_GOLD_30,
    COLOR_GOLD_20,
    COLOR_GOLD_15,
    COLOR_GOLD_20,
    COLOR_GOLD_30,
    COLOR_GOLD_20,
    COLOR_GOLD_20,
  ],
  positions: [0, 0.125, 0.25, 0.375, 0.5, 0.625, 0.75, 0.875, 1],
};
export const GRADIENT_REVENUE_GOLD_SUBTLE: ThemeGradient = {
  angle: 0,
  colors: [COLOR_WHITE, COLOR_GOLD_15],
  positions: [0, 1],
};
export const GRADIENT_REVENUE_GOLD_SUBTLE_ON_DARK: ThemeGradient = {
  angle: 0,
  colors: [COLOR_GRAY_95, COLOR_GOLD_90],
  positions: [0, 1],
};
export const GRADIENT_REVENUE_PLATINUM: ThemeGradient = {
  angle: 45,
  colors: [COLOR_GRAY_95, COLOR_GRAY_60],
  positions: [0, 1],
};
export const GRADIENT_REVENUE_PLATINUM_SHINE: ThemeGradient = {
  angle: 45,
  colors: [COLOR_GRAY_95, COLOR_GRAY_60, COLOR_GRAY_95],
  positions: [0, 0.5, 1],
};
export const GRADIENT_REVENUE_PLATINUM_SHINE_ANIMATION: ThemeGradient = {
  angle: 45,
  colors: [
    COLOR_GRAY_90,
    COLOR_GRAY_90,
    COLOR_GRAY_95,
    COLOR_GRAY_90,
    COLOR_GRAY_80,
    COLOR_GRAY_90,
    COLOR_GRAY_95,
    COLOR_GRAY_90,
    COLOR_GRAY_90,
  ],
  positions: [0, 0.125, 0.25, 0.375, 0.5, 0.625, 0.75, 0.875, 1],
};
export const GRADIENT_REVENUE_PLATINUM_ON_DARK: ThemeGradient = {
  angle: 45,
  colors: [COLOR_GRAY_30, COLOR_GRAY_10],
  positions: [0, 1],
};
export const GRADIENT_REVENUE_PLATINUM_SHINE_ON_DARK: ThemeGradient = {
  angle: 45,
  colors: [COLOR_GRAY_30, COLOR_GRAY_10, COLOR_GRAY_30],
  positions: [0, 0.5, 1],
};
export const GRADIENT_REVENUE_PLATINUM_SHINE_ANIMATION_ON_DARK: ThemeGradient = {
  angle: 45,
  colors: [
    COLOR_GRAY_20,
    COLOR_GRAY_20,
    COLOR_GRAY_30,
    COLOR_GRAY_20,
    COLOR_GRAY_15,
    COLOR_GRAY_20,
    COLOR_GRAY_30,
    COLOR_GRAY_20,
    COLOR_GRAY_20,
  ],
  positions: [0, 0.125, 0.25, 0.375, 0.5, 0.625, 0.75, 0.875, 1],
};
export const GRADIENT_REVENUE_PLATINUM_SUBTLE: ThemeGradient = {
  angle: 0,
  colors: [COLOR_WHITE, COLOR_GRAY_20],
  positions: [0, 1],
};
export const GRADIENT_REVENUE_PLATINUM_SUBTLE_ON_DARK: ThemeGradient = {
  angle: 0,
  colors: [COLOR_GRAY_95, COLOR_GRAY_90],
  positions: [0, 1],
};
export const GRADIENT_REVENUE_PLUS: ThemeGradient = {
  angle: 45,
  colors: [COLOR_BRAND_GRADIENT_START, COLOR_BRAND_GRADIENT_END],
  positions: [0, 1],
};
export const GRADIENT_REVENUE_PLUS_ON_DARK: ThemeGradient = {
  angle: 45,
  colors: [COLOR_BRAND_GRADIENT_START, COLOR_BRAND_GRADIENT_END],
  positions: [0, 1],
};
export const GRADIENT_REVENUE_PLUS_SUBTLE: ThemeGradient = {
  angle: 0,
  colors: [COLOR_WHITE, COLOR_RED_20],
  positions: [0, 1],
};
export const GRADIENT_REVENUE_PLUS_SUBTLE_ON_DARK: ThemeGradient = {
  angle: 0,
  colors: [COLOR_GRAY_95, COLOR_RED_95],
  positions: [0, 1],
};
export const GRADIENT_VAULT_GRADIENT: ThemeGradient = {
  angle: 135,
  colors: [COLOR_PURPLE_60, COLOR_VAULT_PRIMARY, COLOR_BLUE_60],
  positions: [0, 0.5, 1],
};
export const GRADIENT_VAULT_SUBTLE_ON_LIGHT: ThemeGradient = {
  angle: 0,
  colors: [COLOR_WHITE, COLOR_VAULT_INDIGO_20],
  positions: [0, 1],
};
export const GRADIENT_VAULT_SUBTLE_ON_DARK: ThemeGradient = {
  angle: 0,
  colors: [COLOR_GRAY_95, COLOR_VAULT_INDIGO_95],
  positions: [0, 1],
};
export const GRADIENT_MATCH_EXPIRATION_GRADIENT: ThemeGradient = {
  angle: 45,
  colors: [COLOR_MATCH_EXPIRATION_PRIMARY, COLOR_MATCH_EXPIRATION_SECONDARY],
  positions: [0, 1],
};
export const GRADIENT_MATCH_EXPIRATION_GRADIENT_ON_DARK: ThemeGradient = {
  angle: 45,
  colors: [COLOR_MATCH_EXPIRATION_PRIMARY_ON_DARK, COLOR_FUCHSIA_50],
  positions: [0, 1],
};
export const GRADIENT_SPARKS_BACKGROUND_GRADIENT: ThemeGradient = {
  angle: 0,
  colors: [COLOR_SPARKS_GRAY_BLUE_15, COLOR_WHITE],
  positions: [0, 1],
};
export const GRADIENT_SPARKS_BACKGROUND_GRADIENT_DARK: ThemeGradient = {
  angle: 0,
  colors: [COLOR_BLACK, COLOR_BLACK],
  positions: [0, 1],
};
export const GRADIENT_SPARKS_MATCHMAKER_ATTRIBUTION: ThemeGradient = {
  angle: 0,
  colors: [COLOR_SPARKS_GREEN_30, COLOR_SPARKS_GREEN_20],
  positions: [0, 1],
};
export const GRADIENT_GAMEPAD_NOPE = GRADIENT_BRAND_GRADIENT;
